<template>
    <div class="title f32">
      <div class="block"></div>
      <span>{{ title }}</span>
    </div>
</template>

<script>
  export default {
    props: {
      title: {
        type: String,
        required: true
      }
    },
    name: 'order-module-title'
  }
</script>

<style scoped lang="scss">
  .title{
    height: 44px;
    width: 690px;
    display: flex;
    align-items: center;
    font-weight:500;
    .block{
      width:8px;
      height:28px;
      background:rgba(122,223,223,1);
      margin-right: 10px;
    }
  }
</style>
